module.exports = __webpack_public_path__ + "img/paint-x.fe6794c0.svg";